import { createTranslations } from '@npco/utils-translations'

export const contactInfoBoxTranslations = createTranslations({
  text: 'These details will be linked to {contactName}',
})
